import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const createMessageModalSelector = createSelector(modalsSelector, (modals) => modals.createMessage);

export default createMessageModalSelector;
